import { Payload } from './admin-page.type';
import { Company } from './company.type';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  role: string;
  verified: boolean;
  profileImage: null | string;
  enabled: boolean;
  company?: Company;
}

export enum Role {
  User,
  Moderator,
  Admin,
  Superadmin,
}

export type UserPayload = Payload<User & { password: string }>;
